export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const formatShortNumber = (value: number): string => {
  const absValue = Math.abs(value);
  
  if (absValue >= 1000000000) {
    return `${(value / 1000000000).toFixed(1)}B`;
  }
  
  if (absValue >= 1000000) {
    return `${(value / 1000000).toFixed(1)}M`;
  }
  
  if (absValue >= 1000) {
    return `${(value / 1000).toFixed(1)}k`;
  }
  
  return value.toString();
};

export const formatCurrencyShort = (value: number): string => {
  const absValue = Math.abs(value);
  
  if (absValue >= 1000000000) {
    return `R$ ${(value / 1000000000).toFixed(1)}B`;
  }
  
  if (absValue >= 1000000) {
    return `R$ ${(value / 1000000).toFixed(1)}M`;
  }
  
  if (absValue >= 1000) {
    return `R$ ${(value / 1000).toFixed(1)}k`;
  }
  
  return formatCurrency(value);
}; 